export default __webpack_public_path__ + "static/media/Meals4MeMainImage.ece7674c.png";